import { Alert, Box, FormControl, InputLabel, Select, MenuItem, Typography } from "@mui/material"
import { EEslDatetimeLanguage, EEslDatetimeLanguageKeysType } from "../../../../models/enums/eslDatetimeLanguage"
import IEslTemplateItem from "../../../../models/esl/eslTemplateElement";
import { useTranslation } from "react-i18next";
import EslColorPalette from "../../EslColorPalette";

const isBilingualLanguage = (language: EEslDatetimeLanguage | undefined): boolean =>
  language === EEslDatetimeLanguage.BilingualFrenchEnglish || language === EEslDatetimeLanguage.BilingualEnglishFrench;

// TODO: remove the warning Alert + this gate after the sunset date.
// Bilingual was introduced after older mobile builds shipped; we show this
// notice while installs catch up. Two months is the realistic rollout window.
const BILINGUAL_WARNING_SHOWN_UNTIL = new Date('2026-07-15');

interface DatetimeElementPropretiesProps {
  selectedElement: IEslTemplateItem;
  onUpdateElement: (element: IEslTemplateItem) => void;
}

const DatetimeElementPropreties = ({ selectedElement, onUpdateElement }: DatetimeElementPropretiesProps) => {
  const { t } = useTranslation(['eslTemplate', 'common']);

  return (
    <Box>
      <FormControl fullWidth>
        <InputLabel id="language-select-input">{t('eslTemplate:templateEditor.elementPropreties.language')}</InputLabel>
        <Select
          label={t('eslTemplate:templateEditor.elementPropreties.language')}
          labelId="language-select-input"
          value={selectedElement.language || ''}
          onChange={(e) =>
            onUpdateElement({
              ...selectedElement,
              language: e.target.value as EEslDatetimeLanguage,
            })
          }
          sx={{ width: '100%', height: '2em' }}
          MenuProps={{ style: { overflowY: 'visible' } }}
        >
          {Object.keys(EEslDatetimeLanguage)
            .filter((language) => isNaN(Number(language)))
            .map((language) => (
              <MenuItem key={language} value={EEslDatetimeLanguage[language as EEslDatetimeLanguageKeysType]}>
                {t(`eslTemplate:templateEditor.elementPropreties.datetimeLanguageOption.${language}`)}
              </MenuItem>
            ))}
        </Select>
      </FormControl>

      <Box sx={{ mt: 2 }}>
        <EslColorPalette
          selectedColor={selectedElement.style.color}
          onColorSelect={(color) => onUpdateElement({ ...selectedElement, style: { ...selectedElement.style, color } })}
        />
      </Box>

      {isBilingualLanguage(selectedElement.language) && new Date() < BILINGUAL_WARNING_SHOWN_UNTIL && (
        <Alert severity="info" sx={{ mt: 2 }}>
          {t('eslTemplate:templateEditor.elementPropreties.bilingualRequiresLatestAppWarning')}
        </Alert>
      )}

      <Typography variant="body2" mt={2}>
        {t('eslTemplate:templateEditor.elementPropreties.lastCleaningDatetimeDesc')}
      </Typography>
    </Box>
  )
}

export default DatetimeElementPropreties;
